import React, { useEffect, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Link,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { req } from "./api";

import Payments from "./pages/Payments";
import InvoiceHistory from "./pages/InvoiceHistory";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ClientPayment from "./pages/ClientPayment";
import CheckoutRateTest from "./pages/CheckoutRateTest";
import IntegrationSettings from "./pages/IntegrationSettings";
import CheckoutPage from "./pages/CheckoutPage";

function RequireAuth({ authed, children }) {
  const loc = useLocation();
  if (authed === null) return <div style={{ padding: 16 }}>Loading...</div>;
  if (!authed) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  return children;
}

function Shell() {
  const [me, setMe] = useState(null);
  const nav = useNavigate();
  const location = useLocation();

  const isCheckoutPage = location.pathname.startsWith("/checkout/");

  async function loadMe() {
    const r = await req("/api/auth/me");
    setMe(r.json?.user || false);
  }

  useEffect(() => {
    loadMe().catch(() => setMe(false));
  }, []);

  async function logout() {
    await req("/api/auth/logout", { method: "POST" });
    setMe(false);
    nav("/login", { replace: true });
  }

  const authed = Boolean(me && me !== false);

  return (
    <div>
      {!isCheckoutPage && (
        <div
          style={{
            padding: 12,
            borderBottom: "1px solid #ddd",
            display: "flex",
            gap: 12,
            alignItems: "center",
          }}
        >
          <strong>Poteme Pay</strong>

          {authed && (
            <>
              <Link to="/client-payment">Client Payment</Link>
              <Link to="/checkout-rate-test">Rate Test</Link>
              <Link to="/payments">Payments</Link>
              <Link to="/invoices">Invoices</Link>
              <Link to="/integration">Integration</Link>
            </>
          )}

          <div style={{ marginLeft: "auto", display: "flex", gap: 12, alignItems: "center" }}>
            {authed ? (
              <>
                <span>{me.email}</span>
                <button onClick={logout}>Logout</button>
              </>
            ) : (
              <>
                <Link to="/login">Login</Link>
                <Link to="/register">Register</Link>
              </>
            )}
          </div>
        </div>
      )}

      <Routes>
        <Route path="/" element={<Navigate to="/client-payment" replace />} />

        <Route path="/checkout/:sessionId" element={<CheckoutPage />} />

        <Route path="/login" element={<Login onAuthed={loadMe} />} />
        <Route path="/register" element={<Register onAuthed={loadMe} />} />

        <Route
          path="/client-payment"
          element={
            <RequireAuth authed={authed ? true : me === null ? null : false}>
              <ClientPayment />
            </RequireAuth>
          }
        />

        <Route
          path="/checkout-rate-test"
          element={
            <RequireAuth authed={authed ? true : me === null ? null : false}>
              <CheckoutRateTest />
            </RequireAuth>
          }
        />

        <Route
          path="/payments"
          element={
            <RequireAuth authed={authed ? true : me === null ? null : false}>
              <Payments />
            </RequireAuth>
          }
        />

        <Route
          path="/invoices"
          element={
            <RequireAuth authed={authed ? true : me === null ? null : false}>
              <InvoiceHistory />
            </RequireAuth>
          }
        />

        <Route
          path="/integration"
          element={
            <RequireAuth authed={authed ? true : me === null ? null : false}>
              <IntegrationSettings />
            </RequireAuth>
          }
        />

        <Route path="*" element={<Navigate to="/client-payment" replace />} />
      </Routes>
    </div>
  );
}

export default function App() {
  const basename = String(
    process.env.REACT_APP_BASENAME || process.env.PUBLIC_URL || ""
  ).replace(/\/+$/, "");

  return (
    <BrowserRouter basename={basename}>
      <Shell />
    </BrowserRouter>
  );
}
